export default __webpack_public_path__ + "static/HOME-f6da3f0886feb61af29d87a085f1f414.jpg";